<template>
  <div id="main">
    <split-pane v-on:resize="resize" :min-percent='10' :default-percent='20' split="vertical">
      <template slot="paneL">
        <div id="treeDivs">
          <EnumTree :parentMsg="parentMsg" v-on:treeInfo="getTreeInfo"></EnumTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div id="rightName">枚举项</div>
          <hr style="margin-top: 60px"/>
          <div class="rightTopButton">
            <el-button
                    size="small"
                    @click="add()"
                    type="primary"
                    plain>新增</el-button>
          </div>
          <div class="rightContent">
            <el-table
                    border
                    stripe
                    size="small"
                    ref="singleTable"
                    :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                    :data="tableData"
                    highlight-current-row
                    @current-change="handleCurrentChange"
                    height="100%"
                    style="width: 100%;">
              <el-table-column property="name" label="名称"></el-table-column>
              <el-table-column property="code" label="编码" width="220" show-overflow-tooltip></el-table-column>
              <el-table-column property="key" label="索引值" width="220"></el-table-column>
              <el-table-column label="操作" align="center" width="160">
                <template slot-scope="scope">
                  <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-edit"
                          title="编辑"
                          circle
                          plain
                          @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                          size="mini"
                          type="danger"
                          icon="el-icon-delete"
                          title="删除"
                          circle
                          plain
                          @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </split-pane>



    <el-dialog title="添加节点" :visible.sync="dialogFormVisible">
      <el-form :model="enumForm" :rules="rules" ref="enumForm">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="enumForm.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="编码" :label-width="formLabelWidth" prop="code">
          <el-input v-model="enumForm.code" placeholder="编码"></el-input>
        </el-form-item>
        <el-form-item label="索引值" :label-width="formLabelWidth">
          <el-input v-model="enumForm.key"  placeholder="节点索引值，不可重复"></el-input>
        </el-form-item>
        <el-form-item label="排序号" :label-width="formLabelWidth" prop="sortNo">
          <el-input v-model.number="enumForm.sortNo" placeholder="排序号"></el-input>
        </el-form-item>
        <el-form-item label="扩展属性" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="enumForm.extProperty"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="enumForm.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save('enumForm')">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EnumTree from '../components/EnumTree'
import {getCategoryList,delCategory,addCategory} from '../api/category'
export default {
  components: {
    EnumTree: EnumTree
  },
  data () {
    var checkSortNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('排序号不能为空!'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值!'))
        } else {
          callback()
        }
      }, 100)
    }
    return {
      parentMsg: {
        enumTitle: '枚举管理',
        refreshTreeFlag: false
      },
      treeInfo: [],
      tableData: [],
      dialogFormVisible: false,
      enumForm: {
        id: '',
        name: '',
        code: '',
        key: '',
        sortNo: '',
        extProperty: '',
        description: ''
      },
      formLabelWidth: '80px',
      chooseTreeNode: {},
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 42, message: '长度在 1 到 42 个字符之间', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        sortNo: [
          { required: true, message: '请输入排序号', trigger: 'blur' },
          { validator: checkSortNo, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    dialogFormVisible (newVal, oldVal) {
      if (!newVal) {
        this.attrDisabled = false
        this.chooseTreeNode = {}
      }
    },
    treeInfo: function (newVal, oldVal) {
      this.getList(newVal.listenParentId)
    }
  },
  methods: {
    getTreeInfo: function (data) {
      this.treeInfo = data
    },
    getList: function (parentId) {
      getCategoryList('parentId',parentId).then(data => {
        if (data.succeed) {
          this.tableData = data.data
        } else {
          this.$message({
            message: '查询失败！请联系管理员解决！',
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    add () {
      if (this.$refs.enumForm) {
        this.$refs.enumForm.clearValidate()
      }
      this.enumForm = {
        id: '',
        name: '',
        code: '',
        key: '',
        sortNo: '',
        extProperty: '',
        description: ''
      }
      this.dialogFormVisible = true
    },
    handleEdit (index, row) {
      if (this.$refs.enumForm) {
        this.$refs.enumForm.clearValidate()
      }
      this.dialogFormVisible = true
      this.enumForm = row
    },
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCategory(row.id).then(data => {
          if (data.succeed) {
            this.getList(this.treeInfo.listenParentId)
            this.parentMsg = {
              enumTitle: '枚举管理',
              refreshTreeFlag: true
            }
          } else {
            this.$message({
              message: data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    },
    handleCurrentChange (val) {
      this.currentRow = val
    },
    save (enumForm) { // 保存节点
      this.$refs[enumForm].validate((valid) => {
        if (valid) {
          this.enumForm.parentId = this.treeInfo.listenParentId
          addCategory(this.$qs.stringify({
            jsonData: JSON.stringify(this.enumForm)
          })).then(data => {
            if (data.succeed) {
              this.dialogFormVisible = false
              this.getList(this.treeInfo.listenParentId)
              this.parentMsg = {
                enumTitle: '枚举管理',
                refreshTreeFlag: true
              }
            } else {
              this.$message({
                message: data.msg,
                showClose: true,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  /deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4]{
    background-color: #e6eef8;
    width:14px;
  }
  /deep/ .splitter-pane-resizer[data-v-212fa2a4]{
    opacity: initial;
  }
  #main{
    height:100%;
    padding: 0;
    margin: 0;
  }
  #treeDivs{
    width: 99%;
    /* height:calc(100vh - 10px); */
    float: left;
    background: white;
    margin-right: 5px;
    height: 100%;
    /* overflow: auto; */
  }
  #listTables{
    width: 100%;
    float: right;
    background: white;
    height: 100%;
  }
  #rightName {
    float: left;
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-left: 15px;
    margin-top: 15px;
  }
  .rightTopButton {
    text-align: left;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .rightContent {
    height: calc(100vh - 120px);
    background: white;
    /* overflow: auto; */
    padding: 0 10px 10px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/views/EnumManage.vue